module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "z-index": "9999",
      "background-color": "#fff"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin": "0"
    }
  }, [_vm._v("Parallax Effect")]), _vm._v(" "), _c('parallax', [_c('img', {
    attrs: {
      "src": "static/img/pexels-photo-241307.jpeg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "background-color": "#fff",
      "height": "100vh"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("Parallax fixed position ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('parallax', {
    attrs: {
      "fixed": true
    }
  }, [_c('img', {
    attrs: {
      "src": "static/img/pexels-photo-196416.jpeg"
    }
  })]), _vm._v(" "), _vm._m(1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticStyle: {
      "background-color": "#fff",
      "height": "100vh"
    }
  }, [_c('h1', {
    staticStyle: {
      "margin-top": "0",
      "padding-top": "20px"
    }
  }, [_vm._v("Scroll down ⬇")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticStyle: {
      "background-color": "#fff",
      "height": "100vh"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ff94f9be!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 8
// module chunks = 1